import React from 'react'
import PropTypes from 'prop-types'
import { Link, Redirect } from 'react-router-dom'
import api from 'utils/api'

import AdminSubNav from 'components/organisms/AdminSubNav'
import AdminTopNav from 'components/organisms/AdminTopNav'
import Button from 'components/atoms/Button'
import Notice from 'components/atoms/Notice'
import TextField from 'components/molecules/TextField'

class AdminNewLocation extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      location: {
        name: "",
        category: "",
        streetAddress: "",
        city: "",
        state: "",
        zip: "",
        photoUrl: "",
        webUrl: "",
        instagramUrl: "",
      },
      formWasSuccessful: null,
      notice: null
    }

    this.handleFormSubmitted = this.handleFormSubmitted.bind(this)
  }

  render() {
    return (
      <div>
        <AdminTopNav />
        <AdminSubNav>
          <Link to={`/admin/locations`} className="font-meta font-xs">Cancel</Link>
        </AdminSubNav>

        <div className="container-fluid pt-2">
          { this.state.formWasSuccessful && <Redirect to="/admin/locations" /> }

          <main className="row around-xs">
            <div className="col-xs-12 col-md-6">
              { this.renderFormFields() }

              { this.state.notice &&
                <div className="row">
                  <div className="col-xs-12">
                    <Notice
                      text={this.state.notice}
                      style={{ marginBottom: "1em" }}
                    />
                  </div>
                </div>
              }

              <div className="row">
                <div className="col-xs-12">
                  <Button
                    fullWidth
                    onPress={this.handleFormSubmitted}
                  >
                    Create Location
                  </Button>
                </div>
              </div>

            </div>
          </main>
        </div>
      </div>
    )
  }

  renderFormFields() {
    return (
      <div className="FormFields">
        <div className="row">
          <div className="col-xs-12">
            <TextField
              autoFocus
              text="Name"
              id="name"
              placeholder={"e.g. Watercourse Way"}
              onChange={(e) => this.setState({ location: {...this.state.location, name: e.target.value} })}
              value={this.state.location.name}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <TextField
              text="Category"
              id="category"
              placeholder={"e.g. Hip, Charming, Luxe, Outdoor, Solid, Basic"}
              onChange={(e) => this.setState({ location: {...this.state.location, category: e.target.value} })}
              value={this.state.location.category}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <TextField
              text="Street Address"
              id="streetAddress"
              onChange={(e) => this.setState({ location: {...this.state.location, streetAddress: e.target.value} })}
              value={this.state.location.streetAddress}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-6">
            <TextField
              text="City"
              id="city"
              onChange={(e) => this.setState({ location: {...this.state.location, city: e.target.value} })}
              value={this.state.location.city}
            />
          </div>
          <div className="col-xs-2">
            <TextField
              text="State"
              id="state"
              onChange={(e) => this.setState({ location: {...this.state.location, state: e.target.value} })}
              value={this.state.location.state}
            />
          </div>
          <div className="col-xs-4">
            <TextField
              text="Zip"
              id="zip"
              onChange={(e) => this.setState({ location: {...this.state.location, zip: e.target.value} })}
              value={this.state.location.zip}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <TextField
              text="Photo URL"
              id="photoUrl"
              placeholder={"e.g. https://imgur.com/fj3a.jpg (400x300, use imgur direct link)"}
              onChange={(e) => this.setState({ location: {...this.state.location, photoUrl: e.target.value} })}
              value={this.state.location.photoUrl}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <TextField
              text="Web URL"
              id="webUrl"
              placeholder={"e.g. https://www.weareflorens.com"}
              onChange={(e) => this.setState({ location: {...this.state.location, webUrl: e.target.value} })}
              value={this.state.location.webUrl}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <TextField
              text="Instagram URL"
              id="instagramUrl"
              placeholder={"e.g. https://instagram.com/weareflorens"}
              onChange={(e) => this.setState({ location: {...this.state.location, instagramUrl: e.target.value} })}
              value={this.state.location.instagramUrl}
            />
          </div>
        </div>
      </div>
    )
  }

  handleFormSubmitted(){
    const { location } = this.state
    api.submitNewLocation(location)
    .then(res => {
      this.setState({ formWasSuccessful: true })
    })
    .catch(error => {
      console.error("Error: ", error)
      this.setState({ notice: error.toString() })
    })
  }
}

AdminNewLocation.propTypes = {}

export default AdminNewLocation
